import script from "./EmploymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EmploymentPage.vue?vue&type=script&setup=true&lang=js"

import "./EmploymentPage.vue?vue&type=style&index=0&id=4fe3b9b0&lang=css"

const __exports__ = script;

export default __exports__